import React from 'react';
import { FormControl, Select, MenuItem, InputLabel, Box } from '@mui/material';

const TimePeriodSelector = ({ 
  value, 
  onChange, 
  options = [
    { value: 'Today', label: 'Today' },
    { value: 'Last7Days', label: 'Last 7 Days' },
    { value: 'Last30Days', label: 'Last 30 Days' },
    { value: 'Last90Days', label: 'Last 90 Days' }
  ],
  size = 'small',
  sx = {}
}) => {
  return (
    <Box sx={{ minWidth: 160, ...sx }}>
      <FormControl size={size} fullWidth>
        <InputLabel>Time Period</InputLabel>
        <Select
          labelId="time-period-label"
          value={value}
          label="Time Period"
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TimePeriodSelector;
